import { FormControl as MuiFormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FormControl = styled(MuiFormControl)<{ iserrored?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: auto !important;
  position: unset;
  gap: ${theme.spacing.xSmall}px;

  .helper-text {
    color: ${theme.baseColors.info[50]};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.normal};
    font-style: normal;
    line-height: normal;
    position: unset;
  }

  ${({ iserrored }) =>
    iserrored &&
    iserrored === 'true' &&
    `
      .MuiOutlinedInput-root {
        fieldset {
          border-color: ${theme.colors.cta} !important;
        }
      }
    `};

  .form-control-label {
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    font-style: normal;
    line-height: 20px;
    letter-spacing: 0.25px;
    position: unset;

    span {
      color: ${theme.colors.errorLight};
    }
  }

  .MuiOutlinedInput-root {
    width: 100%;

    &.Mui-disabled {
      color: ${theme.colors.foreground};
      -webkit-text-fill-color: ${theme.colors.foreground};

      .MuiOutlinedInput-input {
        &::placeholder {
          color: ${theme.colors.foreground};
          -webkit-text-fill-color: ${theme.colors.foreground};
        }
      }
    }

    .MuiOutlinedInput-input {
      -webkit-text-fill-color: ${theme.colors.devicesSecondaryText} !important;
      color: ${theme.colors.devicesSecondaryText} !important;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-weight: ${theme.typography.fontWeight.bold};
      font-style: normal;
      line-height: 20px;
      letter-spacing: 0.25px;

      &::placeholder {
        overflow: hidden;
        text-overflow: ellipsis;
        opacity: 1;

        -webkit-text-fill-color: ${theme.baseColors.greyscale[50]} !important;
        color: ${theme.baseColors.greyscale[50]} !important;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-weight: ${theme.typography.fontWeight.bold};
        font-style: normal;
        line-height: 20px;
        letter-spacing: 0.25px;
      }

      &.Mui-disabled {
        color: ${theme.colors.foreground};
        -webkit-text-fill-color: ${theme.colors.foreground};
      }
    }
  }

  .MuiFormControl-root {
    width: 100%;
    -webkit-text-fill-color: ${theme.colors.devicesSecondaryText} !important;
    color: ${theme.colors.devicesSecondaryText} !important;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    font-style: normal;
    line-height: 20px;
    letter-spacing: 0.25px;

    .MuiOutlinedInput-root {
      width: 100%;
      -webkit-text-fill-color: ${theme.colors.devicesSecondaryText} !important;
      color: ${theme.colors.devicesSecondaryText} !important;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-weight: ${theme.typography.fontWeight.bold};
      font-style: normal;
      line-height: 20px;
      letter-spacing: 0.25px;

      .MuiOutlinedInput-input {
        -webkit-text-fill-color: ${theme.colors.devicesSecondaryText} !important;
        color: ${theme.colors.devicesSecondaryText} !important;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-weight: ${theme.typography.fontWeight.bold};
        font-style: normal;
        line-height: 20px;
        letter-spacing: 0.25px;

        &::placeholder {
          overflow: hidden;
          text-overflow: ellipsis;
          opacity: 1;

          -webkit-text-fill-color: ${theme.baseColors.greyscale[50]} !important;
          color: ${theme.baseColors.greyscale[50]} !important;
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-weight: ${theme.typography.fontWeight.bold};
          letter-spacing: 0.25px;
          font-style: normal;
          line-height: 20px;
        }
      }
    }
  }
`
